import { formatDollars } from '@kwenta/sdk/utils'
import { createSelector } from '@reduxjs/toolkit'
import { DEFAULT_PERPS_PROVIDER } from 'constants/futures'
import { selectAllMarkPriceInfos, selectMarketsByProvider } from 'state/futures/common/selectors'

import { select24hrPriceChanges } from 'state/prices/selectors'

export const selectMarketsWithPriceInfo = createSelector(
	selectMarketsByProvider,
	selectAllMarkPriceInfos,
	select24hrPriceChanges,
	(marketsByProvider, pricesByProvider, priceChanges) => {
		const markets = marketsByProvider[DEFAULT_PERPS_PROVIDER]
		const markPrices = pricesByProvider[DEFAULT_PERPS_PROVIDER]

		return markets.map((m) => {
			const basePriceRate = markPrices[m.asset]

			const change = priceChanges[m.asset] ?? 0
			return {
				asset: m.asset,
				price: formatDollars(basePriceRate?.price ?? '0', {
					suggestDecimalsForAsset: m.asset,
				}),
				change: change,
				priceDirection: basePriceRate?.change ?? null,
				isMarketClosed: m.isSuspended,
				closureReason: m.marketClosureReason,
			}
		})
	}
)
